import { encryptRole } from 'utils/roles';

const symbol = (firstName, lastName, fullName) => {
  let result = '';
  const first = firstName || fullName.split(' ')[0];
  const last = lastName || fullName.split(' ')[1];
  [first, last].forEach((e) => {
    if (e && e.length) {
      result = result.concat(e.charAt(0));
    }
  });
  return result;
};

const CurrentUser = (data) => ({
  id: data.id,
  email: data.attributes.email,
  firstName: data.attributes.first_name,
  lastName: data.attributes.last_name,
  fullName: data.attributes.full_name,
  role: encryptRole(data.attributes.role),
  symbol: symbol(data.attributes.first_name, data.attributes.last_name, data.attributes.full_name),
});

export default CurrentUser;
